// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".changePassword_changePassword__1uIYg {\n  display: flex;\n  flex-direction: column;\n  max-width: 200px;\n}\n.changePassword_changePassword__1uIYg > * {\n  margin-bottom: 1rem;\n}\n.changePassword_changePassword__1uIYg span {\n  transform: translateY(-1rem);\n  margin-bottom: 0;\n}\n.changePassword_changePassword__1uIYg input {\n  background-color: gray;\n  width: 100%;\n}\n.changePassword_changePassword__1uIYg input::placeholder {\n  color: var(--white-50);\n}", ""]);
// Exports
exports.locals = {
	"changePassword": "changePassword_changePassword__1uIYg"
};
module.exports = exports;
